import { AuthStrategy } from '~constants/auth';

import httpClient from './httpClient';

export const resetPassword = (params, data) => {
	return httpClient({
		method: 'POST',
		url: '/sign-in/reset',
		data,
		params,
	});
};

export const verifyResetToken = (params) => {
	return httpClient({
		method: 'GET',
		url: '/sign-in/reset',
		params,
	});
};

export const forgotPassword = (data) => {
	return httpClient({
		method: 'POST',
		url: '/sign-in/forgot',
		data,
	});
};

export const loginWithCloudflareVerification = (data) => {
	return httpClient({
		method: 'POST',
		url: '/sign-in/cloudflare',
		data,
	});
};

export interface GetAuthStrategyResponse {
	email: string;
	strategy: AuthStrategy;
	isClerkAuthenticationEnabled: boolean;
}
export interface GetAuthStrategyRequestBody {
	email: string;
}
export const getAuthStrategy = (data: GetAuthStrategyRequestBody) => {
	return httpClient.post<GetAuthStrategyResponse>('/auth/strategy', data);
};

export interface ClerkAuthResponse {
	token: string;
	intercomHash: string;
	userId: number;
	roleId: number;
	firstName: string;
	lastName: string;
	email: string;
	isGlobalVerified: boolean;
	uuid: string;
	teamMemberId: number;
	roleName: string;
	business: {
		id: number;
		name: string;
		uuid: string;
		createdAt: string;
	};
}
export interface ClerkAuthRequestBody {
	token: string;
}
export const clerkAuth = (data: ClerkAuthRequestBody) => {
	return httpClient.post<ClerkAuthResponse>('/auth/clerk/session', data);
};
